import { getCurrentUser } from '../auth/session.ts';
import { get, put } from '../utils/http.ts';
import type { Preset } from './preset';

export async function loadPresets(puzzle: string): Promise<Preset[] | null> {
  const email = getCurrentUser().emails[0].email;
  const response = await get<{ presets: Preset[] }>(
    `participant/${encodeURIComponent(email)}/presets?puzzle=${encodeURIComponent(puzzle)}`,
  );

  if (response.error || !response.result) {
    console.error('Error loading presets:', response.error);
    return null;
  }

  return response.result.presets ?? [];
}

export interface PresetSaveResult {
  presets: Preset[] | null;
  error: string | null;
}

export async function savePresets(puzzle: string, presets: Preset[]): Promise<PresetSaveResult> {
  const email = getCurrentUser().emails[0].email;
  const url = `participant/${encodeURIComponent(email)}/presets?puzzle=${encodeURIComponent(puzzle)}`;
  const response = await put<{ presets: Preset[] }, { presets: Preset[] }>(
    url,
    { presets },
  );

  if (response.error || !response.result) {
    console.error('Error saving presets:', response.error);
    return { presets: null, error: response.error ?? 'Something went wrong' };
  }

  return { presets: response.result.presets ?? [], error: null };
}
